// extracted by mini-css-extract-plugin
export default {"container":"NotAuthorized_container__fzUbG","image":"NotAuthorized_image__Zfa9w","header":"NotAuthorized_header__PD19Q","body":"NotAuthorized_body__1gu3f"};